"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_MAX_INSTANCES = void 0;
/** Default max instances for fieldsets when not specified. */
const DEFAULT_MAX_INSTANCES = exports.DEFAULT_MAX_INSTANCES = 10;